import styled, { css } from 'styled-components/macro';

export const Badge = styled.span<{ backgroundColor?: string; fontColor?: string }>`
  ${({ backgroundColor, fontColor }) =>
    css`
       {
        border-radius: 24px;
        background: ${backgroundColor};
        padding: 3px 13px 3px 11px !important;
        font-size: 12px;
        line-height: 1.5;
        color: ${fontColor};
      }
    `}
`;
